// Eje 1 — Ubicación: recintos RC-01..33 (RC-01..24 de la hoja "Ubicación"
// del xlsx; RC-25..33 son correcciones de contenido agregadas al final —
// ver los comentarios junto a cada una y ADR-0135).
// `requiereInstancia` es contenido del catálogo; la resolución de
// instancias (ADR-0118) está diferida por ruling del founder 2026-09-01.
export const RECINTOS = [
    {
        codigo: "RC-01",
        nombre: "Acceso / hall de la unidad",
        ambito: "privado",
        requiereInstancia: false,
    },
    { codigo: "RC-02", nombre: "Living - comedor", ambito: "privado", requiereInstancia: false },
    { codigo: "RC-03", nombre: "Cocina", ambito: "privado", requiereInstancia: false },
    { codigo: "RC-04", nombre: "Logia", ambito: "privado", requiereInstancia: false },
    {
        codigo: "RC-05",
        nombre: "Baño principal / en suite",
        ambito: "privado",
        requiereInstancia: false,
    },
    { codigo: "RC-06", nombre: "Baño secundario", ambito: "privado", requiereInstancia: true },
    {
        codigo: "RC-07",
        nombre: "Baño de visitas / toilette",
        ambito: "privado",
        requiereInstancia: false,
    },
    { codigo: "RC-08", nombre: "Dormitorio principal", ambito: "privado", requiereInstancia: false },
    { codigo: "RC-09", nombre: "Dormitorio secundario", ambito: "privado", requiereInstancia: true },
    {
        codigo: "RC-10",
        nombre: "Dormitorio de servicio",
        ambito: "privado",
        requiereInstancia: false,
    },
    { codigo: "RC-11", nombre: "Pasillo interior", ambito: "privado", requiereInstancia: false },
    { codigo: "RC-12", nombre: "Terraza / balcón", ambito: "privado", requiereInstancia: true },
    { codigo: "RC-13", nombre: "Bodega", ambito: "privado", requiereInstancia: false },
    {
        codigo: "RC-14",
        nombre: "Estacionamiento de la unidad",
        ambito: "privado",
        requiereInstancia: true,
    },
    { codigo: "RC-15", nombre: "Fachada de la unidad", ambito: "privado", requiereInstancia: false },
    {
        codigo: "RC-16",
        nombre: "Hall / lobby del edificio",
        ambito: "comun",
        requiereInstancia: false,
    },
    { codigo: "RC-17", nombre: "Pasillo / escalera común", ambito: "comun", requiereInstancia: true },
    { codigo: "RC-18", nombre: "Ascensor", ambito: "comun", requiereInstancia: true },
    {
        codigo: "RC-19",
        nombre: "Sala multiuso / quincho común",
        ambito: "comun",
        requiereInstancia: false,
    },
    { codigo: "RC-20", nombre: "Sala de basura", ambito: "comun", requiereInstancia: false },
    { codigo: "RC-21", nombre: "Estacionamiento común", ambito: "comun", requiereInstancia: false },
    { codigo: "RC-22", nombre: "Área verde / paisajismo", ambito: "comun", requiereInstancia: false },
    { codigo: "RC-23", nombre: "Techumbre / azotea", ambito: "comun", requiereInstancia: false },
    { codigo: "RC-24", nombre: "Subterráneo", ambito: "comun", requiereInstancia: true },
    // Corrección de contenido 2026-09-05 (founder): el xlsx fuente se generó
    // con ayuda de IA y omitió este recinto. «Sala de estar» es, en general,
    // un espacio PROPIO y distinto del living-comedor — una unidad puede
    // tener los dos —, y hasta hoy el prompt enseñaba explícitamente que
    // eran la misma fila. Esa equivalencia falsa mapeaba a RC-02 todo lo que
    // el supervisor dictara como «sala de estar».
    //
    // Va como RC-25 al final y no intercalado junto a RC-02: el código ES la
    // identidad de la fila, y renumerar reescribiría la procedencia de cada
    // observación ya clasificada.
    //
    // NO bumpea TAXONOMY_VERSION_CURRENT, y esto es una excepción declarada,
    // no la regla: agregar un código cambia el espacio de códigos y en un
    // catálogo publicado obligaría a versionar (el registry es un Map por
    // versión precisamente para que una fila histórica decodifique contra la
    // suya). Se corrige en el lugar porque 2.1-mvp todavía no tiene un solo
    // cliente real ni un acta firmada que dependa de él, y sostener dos
    // catálogos para una demo es maquinaria sin consumidor. El día que exista
    // el primer cliente, el próximo cambio de filas SÍ bumpea.
    //
    // 2026-10-08 (ruling del founder): la excepción se usó UNA vez más, para
    // RC-26..33 de abajo, porque sigue sin existir un cliente real de
    // postventa en producción. Con eso queda agotada: el PRÓXIMO cambio de
    // filas —agregar, renombrar con cambio de sentido o retirar— SÍ bumpea
    // TAXONOMY_VERSION_CURRENT y registra un catálogo nuevo en el registry.
    { codigo: "RC-25", nombre: "Sala de estar", ambito: "privado", requiereInstancia: false },
    // Corrección de contenido 2026-10-08 (demo postventa del 2026-10-07): el
    // catálogo sólo conocía el quincho del condominio (RC-19, común) y el
    // canal del propietario descarta los recintos comunes, así que «el
    // quincho de mi casa» quedaba sin recinto. Un recinto que existe tanto
    // dentro de la unidad como en el edificio se modela como DOS filas, cada
    // una con su ámbito: la común lleva el sufijo «común» y la privada «de la
    // unidad». Jamás un ámbito «ambos» y jamás se cambia el ámbito de un
    // código publicado (ADR-0135). Se agrega además el lote de recintos de
    // casa que el xlsx —pensado para departamentos— no traía.
    {
        codigo: "RC-26",
        nombre: "Quincho de la unidad",
        ambito: "privado",
        requiereInstancia: false,
    },
    {
        codigo: "RC-27",
        nombre: "Patio / jardín de la unidad",
        ambito: "privado",
        requiereInstancia: false,
    },
    { codigo: "RC-28", nombre: "Entretecho / altillo", ambito: "privado", requiereInstancia: false },
    {
        codigo: "RC-29",
        nombre: "Walk-in closet / vestidor",
        ambito: "privado",
        requiereInstancia: true,
    },
    {
        codigo: "RC-30",
        nombre: "Escritorio / home office",
        ambito: "privado",
        requiereInstancia: false,
    },
    { codigo: "RC-31", nombre: "Escalera interior", ambito: "privado", requiereInstancia: false },
    {
        codigo: "RC-32",
        nombre: "Piscina / tina de la unidad",
        ambito: "privado",
        requiereInstancia: false,
    },
    {
        codigo: "RC-33",
        nombre: "Sala de calderas / ducto técnico de la unidad",
        ambito: "privado",
        requiereInstancia: false,
    },
];
//# sourceMappingURL=recintos.js.map